var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('comment',{attrs:{"comment":_vm.value},on:{"editComment":function($event){return _vm.$emit('editComment', $event)},"deleteComment":function($event){return _vm.$emit('deleteComment', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }